import React from 'react';
import { Shield } from 'lucide-react';
import { Box, LinearProgress, Typography } from '@mui/material';

const PasswordStrength = ({ strength }) => {
    const getStrengthLabel = (value) => {
        if (value > 80) return { label: 'Strong', color: 'success.main' };
        if (value > 50) return { label: 'Moderate', color: 'warning.main' };
        return { label: 'Weak', color: 'error.main' };
    };

    const strengthInfo = getStrengthLabel(strength);

    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 1,
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Shield size={20} style={{ color: '#4caf50' }} />
                    <Typography variant="body2" fontWeight="medium">
                        Password Strength
                    </Typography>
                </Box>
                <Typography
                    variant="body2"
                    fontWeight="medium"
                    sx={{ color: strengthInfo.color }}
                >
                    {strengthInfo.label}
                </Typography>
            </Box>
            <LinearProgress
                variant="determinate"
                value={strength}
                sx={{
                    height: 10,
                    borderRadius: 5,
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: strengthInfo.color,
                    },
                }}
            />
        </Box>
    );
};

export default PasswordStrength;
